import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { closeFullScreen, enterFullScreen } from '../../lib/helpers';
import { FullScreenContext } from './FullScreenContext';

const FullScreenManager = ({ children }) => {
	const [fullScreen, setFullScreen] = useState(false);
	const isFullScreenEnabled = document.fullscreenEnabled;

	const onClickFullScreen = (element) => {
		if (document.fullscreenElement) {
			closeFullScreen();
		} else {
			enterFullScreen(element);
		}
	};

	useEffect(() => {
		const setFullScreenState = () => {
			if (document.fullscreenElement) {
				setFullScreen(true);
			} else {
				setFullScreen(false);
			}
		};
		window.addEventListener('fullscreenchange', setFullScreenState);
		return () => {
			window.removeEventListener('fullscreenchange', setFullScreenState);
		};
	}, []);

	return (
		<FullScreenContext.Provider value={{
			onClickFullScreen,
			fullScreen,
			isFullScreenEnabled,
		}}
		>
			{children}
		</FullScreenContext.Provider>
	);
};

FullScreenManager.defaultProps = {
	children: null,
};

FullScreenManager.propTypes = {
	children: PropTypes.node,
};
export default FullScreenManager;
